import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";

const ACTION_PREFIX = "[Rehydrate]";
export const REHYDRATE_ACTION_TYPE = {
	rehydrateGenerate: `${ACTION_PREFIX} GENERATE`,
};

@Injectable({
	providedIn: "root",
})
export class RehydrateAction {
	rehydrate(): Action {
		return {
			type: REHYDRATE_ACTION_TYPE.rehydrateGenerate,
		};
	}
}
